import { provide, ref } from 'vue'

export const useEditProfileModeProvider = () => {
  const isEditModeEnabled = ref(false)

  const toggleEditMode = () => {
    isEditModeEnabled.value = !isEditModeEnabled.value
  }

  const enableEditMode = () => {
    isEditModeEnabled.value = true
  }

  const disableEditMode = () => {
    isEditModeEnabled.value = false
  }

  provide('isEditModeEnabled', isEditModeEnabled)
  provide('toggleEditMode', toggleEditMode)
  provide('enableEditMode', enableEditMode)
  provide('disableEditMode', disableEditMode)

  return {
    isEditModeEnabled,
    toggleEditMode,
    enableEditMode,
    disableEditMode,
  }
}
